// extracted by mini-css-extract-plugin
export default {"more2":"SubcategoryPage_more2_eneDk","more":"SubcategoryPage_more_qkgJJ","expanded":"SubcategoryPage_expanded_wjgs_"};